import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  TextField
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
// Import all CSS modules in the same order as parent to ensure consistent webpack ordering
// eslint-disable-next-line no-unused-vars
import _complainStyles from '../complain.module.css';
// eslint-disable-next-line no-unused-vars
import _deleteModalStyles from './delete.module.css';
import styles from './statusChange.module.css';
// eslint-disable-next-line no-unused-vars
import _viewStudentStyles from './viewStudent.module.css';
// eslint-disable-next-line no-unused-vars
import _rejectComplaintStyles from './reject_complaint.module.css';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';

const OtpVerificationModal = ({ open, onClose, onConfirm, complaint, initialStatus = 'resolved' }) => {
  const [selectedStatus, setSelectedStatus] = useState(initialStatus);
  const [remark, setRemark] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // OTP state
  const OTP_LENGTH = 6;
  const [otp, setOtp] = useState(Array(OTP_LENGTH).fill(''));
  const [otpSent, setOtpSent] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(0);
  const inputsRef = useRef([]);

  console.log('complaint in status change', complaint);
  console.log('StatusChange modal open:', open);

  useEffect(() => {
    setSelectedStatus(initialStatus || 'resolved');
    setRemark('');
  }, [complaint, initialStatus]);

  const isSimpleOtp = ['in progress', 'resolved'].includes(String(initialStatus || '').toLowerCase());
  const complainantName =
    complaint?.createdByUser?.name ||
    complaint?.studentName ||
    complaint?.name ||
    'Complainant';
  const complainantPhone =
    complaint?.createdByUser?.phoneNumber ||
    complaint?.createdByUser?.mobileNumber ||
    complaint?.phoneNumber ||
    complaint?.mobileNumber ||
    '';
  const complainantInitial = String(complainantName).trim().charAt(0).toUpperCase() || 'U';

  // console.log('complaint ---->', complaint);

  // countdown
  useEffect(() => {
    if (!otpSent || secondsLeft <= 0) return;
    const id = setInterval(() => setSecondsLeft((s) => s - 1), 1000);
    return () => clearInterval(id);
  }, [otpSent, secondsLeft]);

  const handleSendOtp = async () => {
    try {
      // TODO: integrate API to send OTP
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/hospital/hospital-complaints/send-resolve-otp`,
        { complaintId: complaint?.complaintId },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${Cookies.get('Token')}`
          }
        }
      );
      console.log(res);

      setOtp(Array(OTP_LENGTH).fill(''));
      setOtpSent(true);
      setSecondsLeft(60);
      inputsRef.current[0]?.focus();
      toast.success(`OTP sent successfully`);
    } catch (e) {
      console.log(e);
      toast.error('Failed to send OTP');
    }
  };

  const handleResend = () => {
    if (secondsLeft > 0) return;
    handleSendOtp();
  };

  // const handleVerify = async () => {
  //   const code = otp.join('');
  //   if (code.length !== OTP_LENGTH) {
  //     toast.error('Please enter full OTP');
  //     return;
  //   }
  //   try {
  //     // TODO: verify OTP via API
  //     toast.success('OTP verified');
  //   } catch (e) {
  //     toast.error('Invalid OTP');
  //   }
  // };

  const handleOtpChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;
    const next = [...otp];
    next[index] = value;
    setOtp(next);
    if (value && index < OTP_LENGTH - 1) inputsRef.current[index + 1]?.focus();
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };



  const handleSave = async () => {
    setIsLoading(true);
    const code = otp.join('');
    if (code.length !== OTP_LENGTH) {
      toast.error('Please enter full OTP');
      setIsLoading(false);
      return;
    }
    try {
      const complaintId = complaint?.complaintId;
      const payload = isSimpleOtp
        ? { complaintId, otp: code }
        : { complaintId, status: selectedStatus.toLowerCase(), remark, otp: code };

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/hospital/hospital-complaints/verify-resolve-otp`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${Cookies.get('Token')}`
          }
        }
      );
      toast.success(response?.data?.message || 'OTP verified successfully.');
      onConfirm?.();
      onClose?.();
      // Don't close automatically, let the parent handle it
    } catch (error) {
      // toast.error('Invalid OTP');
      toast.error(error.response.data.message || error.response.data.messeage || 'Something went wrong please retry');
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    console.log('StatusChange modal closing');
    setSelectedStatus(initialStatus || 'resolved');
    setRemark('');
    setOtp(Array(OTP_LENGTH).fill(''));
    setOtpSent(false);
    setSecondsLeft(0);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="500px" fullWidth className={styles.statusChangeModal}>
      {/* Header */}
      <DialogTitle className={styles.modalHeader}>
        <Typography variant="h6" className={styles.modalTitle}>
          {isSimpleOtp ? 'OTP Verification' : 'Change Status'}
        </Typography>
        <IconButton onClick={handleClose} className={styles.closeButton}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Content */}
      <DialogContent className={styles.modalContent}>
        {isSimpleOtp && (
          <>
            <Box className={styles.otpInfo}>
              <div className={styles.otpAvatar}>{complainantInitial}</div>
              <Typography className={styles.otpMessage}>
                An OTP has been sent to {complainantName} on this mobile number
               
                {complainantPhone ? ` ${complainantPhone}` : "'s registered phone number"} . Please obtain the OTP from the complainant.
              </Typography>
            </Box>

            <Box className={styles.otpHeaderRow}>
              <Typography variant="body2" className={styles.fieldLabel}>
                Enter 6-Digit OTP
              </Typography>
              <Button size="small" className={styles.sendOtpBtn} onClick={handleSendOtp} disabled={otpSent && secondsLeft > 0}>
                {otpSent ? 'Resend OTP' : 'Send OTP'}
              </Button>
            </Box>

            <Box className={styles.otpInputsRow}>
              {Array.from({ length: OTP_LENGTH }).map((_, i) => (
                <input
                  key={i}
                  ref={(el) => (inputsRef.current[i] = el)}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  value={otp[i]}
                  onChange={(e) => handleOtpChange(i, e.target.value)}
                  onKeyDown={(e) => handleOtpKeyDown(i, e)}
                  className={styles.otpInput}
                />
              ))}
            </Box>

            <Box className={styles.otpMetaRow}>
              <Typography className={styles.otpTimer}>{`00:${String(otpSent ? secondsLeft : 0).padStart(2, '0')}s`}</Typography>
              <Button
                size="small"
                onClick={handleResend}
                className={styles.resendBtn}
                disabled={!otpSent || secondsLeft > 0}
              >
                Resend Code
              </Button>
            </Box>
          </>
        )}

        {!isSimpleOtp && (
          <>
        {/* Status Field */}
        <Box className={styles.formField}>
          <Typography variant="body2" className={styles.fieldLabel}>
            Status
          </Typography>
          <FormControl fullWidth size="small">
            <Select value={selectedStatus} onChange={(e) => setSelectedStatus(e.target.value)} className={styles.statusSelect}>
              {/* <MenuItem value="pending">Pending</MenuItem> */}
              {/* <MenuItem value="in progress">In Progress</MenuItem> */}
              {/* <MenuItem value="resolved">Resolved</MenuItem> */}
              {/* <MenuItem value="rejected">Rejected</MenuItem> */}
              {/* <MenuItem value="pending" disabled={['resolved', 'rejected'].includes(complaint?.status)}>
                Pending
              </MenuItem> */}
              {/* <MenuItem value="in progress">In Progress</MenuItem> */}
              <MenuItem value="in progress">In Progress</MenuItem>
              <MenuItem value="resolved">Resolved</MenuItem>
              <MenuItem value="rejected">Rejected</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Remark Field */}
        {selectedStatus?.toLowerCase() !== 'pending' && (
          <>
            <Box className={styles.formField}>
              <Typography variant="body2" className={styles.fieldLabel}>
                Remark
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={3}
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="Enter remark"
                className={styles.remarkField}
                size="small"
              />
            </Box>

              {/* OTP Section */}
            <Box className={styles.formField}>
              <Box className={styles.otpHeaderRow}>
                <Typography variant="body2" className={styles.fieldLabel}>
                  OTP verification
                </Typography>
                <Button size="small" className={styles.sendOtpBtn} onClick={handleSendOtp} disabled={otpSent && secondsLeft > 0}>
                  {otpSent ? 'Resend OTP' : 'Send OTP'}
                </Button>
              </Box>

              <Box className={styles.otpInputsRow}>
                {Array.from({ length: OTP_LENGTH }).map((_, i) => (
                  <input
                    key={i}
                    ref={(el) => (inputsRef.current[i] = el)}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    value={otp[i]}
                    onChange={(e) => handleOtpChange(i, e.target.value)}
                    onKeyDown={(e) => handleOtpKeyDown(i, e)}
                    className={styles.otpInput}
                  />
                ))}
              </Box>

              {otpSent && (
                <Box className={styles.otpMetaRow}>
                  <Typography className={styles.otpTimer}>{`00:${String(secondsLeft).padStart(2, '0')}s`}</Typography>
                  <Button size="small" onClick={handleResend} className={styles.resendBtn} disabled={secondsLeft > 0}>
                    Resend Code
                  </Button>
                </Box>
              )}

              {/* <Button fullWidth className={styles.verifyBtn} variant="contained" >
   verify
 </Button> */}
            </Box>
          </>
        )}
          </>
        )}
      </DialogContent>

      {/* Actions */}
      <DialogActions className={styles.modalActions}>
        <Button onClick={handleClose} variant="outlined" className={styles.cancelButton} disabled={isLoading}>
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" className={styles.saveButton} disabled={!otpSent && isLoading}>
          {isLoading ? 'Saving...' : isSimpleOtp ? 'Verify OTP' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OtpVerificationModal;
